import { render, staticRenderFns } from "./SuicideFacts.vue?vue&type=template&id=5b3e97ec&scoped=true"
import script from "./SuicideFacts.vue?vue&type=script&lang=js"
export * from "./SuicideFacts.vue?vue&type=script&lang=js"
import style0 from "./SuicideFacts.vue?vue&type=style&index=0&id=5b3e97ec&prod&lang=scss&scoped=true"
import style1 from "./SuicideFacts.vue?vue&type=style&index=1&id=5b3e97ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e97ec",
  null
  
)

export default component.exports